import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { encodeImageUrl, getDotBorderColor, useColorButtonStyles } from './colorButton.styles';
import { ColorButtonProps } from './colorButton.types';

const ColorButton = ({
  label,
  hexcode,
  imageUrl,
  isSelected = false,
  size = 'sm',
  tabIndex = 0,
  testId,
  onClick,
}: ColorButtonProps) => {
  const theme = useTheme();
  const { classes, cx } = useColorButtonStyles({
    dotBorderColor: getDotBorderColor(theme, imageUrl ? undefined : hexcode),
    size,
  });

  const dotStyle = imageUrl
    ? { backgroundImage: `url(${encodeImageUrl(imageUrl)})` }
    : { backgroundColor: hexcode };

  return (
    <Tooltip TooltipContent={label} tabIndex={-1}>
      <ButtonBase
        aria-label={label}
        aria-pressed={isSelected}
        tabIndex={tabIndex}
        test-id={testId}
        className={cx(classes.button, isSelected && classes.buttonSelected)}
        onClick={onClick}
      >
        <span className={classes.dot} style={dotStyle} />
      </ButtonBase>
    </Tooltip>
  );
};

export default ColorButton;
